import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../components/pages/reducers';
import sagas from '../components/pages/sagas';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, {}, composeEnhancers(
	applyMiddleware(
		sagaMiddleware
	)
));

/* istanbul ignore if */
if (module.hot) {
	module.hot.accept('../components/pages/reducers', () => {
		const nextReducer = require('../components/pages/reducers').default;

		store.replaceReducer(nextReducer);
	});
}

sagaMiddleware.run(sagas);

window.store = store;
export default store;
